import { addClass, toggleClass } from '../../common/Utils';
import { toastClass } from '../constants/class';
import { toastDefaultOptions } from '../constants/options';
import { ModalOption, ModalPromiseResult } from '../../interface/IModal';
import AbstractNotification from './AbstractNotification';

export default class Toast extends AbstractNotification {
    constructor() {
        super();
    }

    async open(options?: ModalOption): Promise<ModalPromiseResult> {
        super.open({ ...toastDefaultOptions, ...options });
        // class 추가
        this.addClassForToast();
        this.addClassForToastAnimation();

        return new Promise((resolve) => {
            // 이벤트 추가
            super.addEventsByOptions(resolve);
            super.setTimerOption(resolve);
        });
    }
    private addClassForToast(): void {
        addClass(
            this.$backdrop,
            `${
                this.options.isVertical
                    ? toastClass.TOAST_TYPE_VERTICAL
                    : toastClass.TOAST_TYPE_HORIZONTAL
            }`
        );
        addClass(this.$backdrop, toastClass.TOAST);
    }
    private addClassForToastAnimation(): void {
        addClass(this.$backdrop, toastClass.TOAST);
        !!this.options.showClass
            ? addClass(this.$backdrop, this.options.showClass)
            : addClass(this.$modalContent, toastClass.TOAST_SHOW);
    }
    protected removeClassForAnimation(): void {
        toggleClass(this.$modalContent, toastClass.TOAST_SHOW);
        !!this.options.hideClass
            ? toggleClass(this.$backdrop, this.options.hideClass)
            : toggleClass(this.$modalContent, toastClass.TOAST_HIDE);

        super.removeClassForAnimation();
    }
}
